import { Card, Flex } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";
import { AssignmentInput } from "../inputs/AssignmentInput";
import { DescriptionInput } from "../inputs/DescriptionInput";
import { DowntimeInputItem } from "../inputs/DowntimeInputItem";
import { DuedateInput } from "../inputs/DuedateInput";
import { FrequencyInputItem } from "../inputs/FrequencyInputItem";
import { IssueInput } from "../inputs/IssueInput";
import { MaterialInputItem } from "../inputs/MaterialInputItem";
import { MediaInputItem } from "../inputs/MediaInputItem";
import { MetaInput } from "../inputs/MetaInput";
import { PriorityInput } from "../inputs/PriorityInput";
import { ProjectInput } from "../inputs/ProjectInput";
import { RestrictionInputItem } from "../inputs/RestrictionInputItem";
import { SourceInput } from "../inputs/SourceInput";
import { StateInput } from "../inputs/StateInput";
import { SubmitButton } from "../inputs/SubmitButton";
import { TitleInput } from "../inputs/TitleInput";

type Props = {};

export const CompactView = observer((props: Props) => {
  return (
    <Card
      size="small"
      title={<TitleInput noStyle />}
      extra={<DuedateInput type="range" noStyle />}
      styles={{
        header: { margin: 0, padding: 0, minHeight: "unset" },
        body: { padding: 0, margin: 0 },
        title: { minWidth: "200px" },
      }}
      variant="borderless"
    >
      <Flex vertical gap="small">
        <DescriptionInput noStyle />
        <Flex gap="small" wrap align="flex-end">
          <Flex gap="small" wrap style={{ flex: 1 }} justify="space-between">
            <PriorityInput type="dropdown" noStyle />
            <RestrictionInputItem type="dropdown" noStyle />
            <FrequencyInputItem type="dropdown" noStyle />
            <DowntimeInputItem type="dropdown" noStyle />
            <StateInput type="dropdown" noStyle />
            <IssueInput noStyle size="small" />
            <ProjectInput type="dropdown" noStyle />
            <AssignmentInput type="dropdown" noStyle />
            <SourceInput type="dropdown" noStyle />
            <MaterialInputItem type="dropdown" noStyle />
            <MediaInputItem type="dropdown" noStyle />
            <MetaInput type="modal" noStyle />
            <div style={{ flex: 1 }} />
            <SubmitButton size="small" />
          </Flex>
        </Flex>
      </Flex>
    </Card>
  );
});
